/*
 * @Author: Han
 * @Date: 2022-03-02 09:29:43
 * @LastEditors: Han
 * @LastEditTime: 2022-03-02 11:12:18
 * @FilePath: \console\src\http\moudules\newsInformation.js
 */
import axios from '../axios'
// 获取列表

export const getNewsList = (data) => {
  return axios({
    url: '/information/queryInformationByPage',
    method: 'GET',
    data
  })
}
// 添加新闻图片
export const addNewsImg = (data) => {
  return axios({
    url: '/information_image/insert',
    method: 'GET',
    data
  })
}
// 获取新闻图片地址
export const getNewsImgList = (data) => {
  return axios({
    url: '/information_image/get',
    method: 'GET',
    data
  })
}
// 更新新闻图片
export const upNewsImg = (data) => {
  return axios({
    url: '/information_image/update',
    method: 'POST',
    data
  })
}
// 新增新闻资讯
export const addNew = (data) => {
  return axios({
    url: '/information/insert',
    method: 'POST',
    data
  })
}
// 修改新闻资讯
export const upNew = (data) => {
  return axios({
    url: '/information/update',
    method: 'POST',
    data
  })
}
// 上下新闻资讯
export const opNew = (data) => {
  return axios({
    url: '/information/operate',
    method: 'POST',
    data
  })
}
// 删除新闻资讯
export const delNew = (data) => {
  return axios({
    url: '/information/delete',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/newsInformation.js